import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import './Footer.css';
import Logo from './logo1.png';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaInstagram, FaLinkedin, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLinkClick = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');

      const waitForElement = setInterval(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          clearInterval(waitForElement);
        }
      }, 100);

      setTimeout(() => {
        clearInterval(waitForElement);
      }, 5000);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const renderFooterLink = (to, label, sectionId) => {
    if (location.pathname === '/') {
      return (
        <ScrollLink
          to={sectionId}
          smooth={true}
          duration={800}
          className="footer-item"
        >
          {label}
        </ScrollLink>
      );
    } else {
      return (
        <span
          className="footer-item"
          onClick={() => {
            handleLinkClick(sectionId);
          }}
        >
          {label}
        </span>
      );
    }
  };

  return (
    <>
      <footer className="footer-section">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <img src={Logo} alt="Logo SBK Technologies" className="navbar-logo" />
            </div>
            <div className="footer-links">
              <h4>Enlaces</h4>
              <ul>
                <li>{renderFooterLink('/', 'Inicio', 'hero-section')}</li>
                <li>{renderFooterLink('/about', 'Nosotros', 'team-section')}</li>
                <li>{renderFooterLink('/services', 'Servicios', 'services-section')}</li>
                <li>{renderFooterLink('/portfolio', 'Portafolio', 'portfolio-carousel')}</li>
                <li><a href="/contact">Contáctanos</a></li>
              </ul>
            </div>
            <div className="footer-contact">
              <h4>Contáctanos</h4>
              <p>Correo: <a href="mailto:contacto@sbksoluciones.com">contacto@sbksoluciones.com</a></p>
              <p>Teléfono: <a href="tel:+56995111286">+56 995 111 286</a></p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>Copyright © SBK 2024</p>
            <div className="footer-social">
              <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
                <FaLinkedin className="social-icon" />
              </a>
              <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                <FaInstagram className="social-icon" />
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Botón flotante de WhatsApp */}
      <div className="whatsapp-floating-button">
        <a
          href="https://wa.me/+56995111286?text=Hola,%20quiero%20contactarme%20con%20ustedes"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp className="whatsapp-icon" />
        </a>
      </div>
    </>
  );
};

export default Footer;
